import React from "react";
import './Privatepolicy.css'

const Privatepolicy = () => {
  return (
    <div
      className="privacy-policy"
      style={{ padding: "20px", paddingTop:"40px",lineHeight: "1.7" }}
    >
      <h1>Privacy Policy</h1>
      <p>
        <strong>Last Updated:</strong> 13 January 2026
      </p>

      <p>
        <strong>Viyavar Fashions Private Limited</strong> (“Viyavar”, “we”,
        “our”, or “us”) respects every user of our services and is committed to
        protecting your privacy when you use our website, mobile application, or
        related services (collectively, the “Services”).
      </p>

      <p>
        Your trust is important to us. We do not rent or sell your personal
        information to third parties, and we do not send spam. This Privacy
        Policy explains what information we collect, how we collect it, how it
        is used, and the choices you have regarding your information.
      </p>

      <p>
        We reserve the right to modify this Privacy Policy at any time. Any
        changes will be effective immediately upon posting on our website. Your
        continued use of the Services after such changes constitutes acceptance
        of the updated Privacy Policy.
      </p>

      <h2>Use of Personal Information</h2>
      <p>
        You may browse our Services without creating an account. However,
        certain features such as placing orders, managing subscriptions,
        tracking deliveries, or contacting customer support may require you to
        provide personal information.
      </p>

      <p>We may collect personal information including but not limited to:</p>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Billing and shipping address</li>
        <li>Login credentials</li>
        <li>Order and transaction details</li>
        <li>Device and browser information</li>
      </ul>

      <p>This information is used to:</p>
      <ul>
        <li>Provide and manage our Services</li>
        <li>Process orders and payments</li>
        <li>Communicate with you regarding your account or orders</li>
        <li>Improve user experience and personalize content</li>
        <li>Comply with legal and regulatory requirements</li>
      </ul>

      <h2>Payment Information</h2>
      <p>
        Payments on our platform are processed through secure third-party
        payment gateways such as <strong>Razorpay</strong>. We do not store or
        process your card or banking details on our servers. Payment data is
        handled directly by the payment gateway in accordance with their privacy
        policies and security standards.
      </p>

      <h2>Non-Personal Information</h2>
      <ul>
        <li>IP address</li>
        <li>Browser type</li>
        <li>Device details</li>
        <li>Pages visited and usage patterns</li>
      </ul>

      <h2>Cookies & Tracking Technologies</h2>
      <p>
        We use cookies and similar technologies to improve functionality,
        remember preferences, and analyze traffic. Disabling cookies may affect
        certain features of the Services.
      </p>

      <h2>Sharing of Information</h2>
      <ul>
        <li>
          With payment gateways, delivery partners, and IT service providers
        </li>
        <li>To comply with legal obligations</li>
        <li>During business transfers such as mergers or acquisitions</li>
      </ul>

      <h2>Delivery & Logistics Data</h2>
      <p>
        Delivery-related information may be shared with third-party delivery
        partners solely for order fulfillment. Viyavar Fashions is not
        responsible for the privacy practices of these delivery partners.
      </p>

      <h2>Data Retention</h2>
      <p>
        We retain personal information only as long as necessary for service
        fulfillment and legal compliance. Data is securely deleted or anonymized
        when no longer required.
      </p>

      <h2>User Data Deletion</h2>
      <p>
        You may request deletion of your personal data by contacting us at:
        <br />
        <strong>Email:</strong> viyavarfashion@gmail.com
      </p>
      <p>
        Verified requests will be processed within 5–7 business days, subject to
        legal requirements. Certain transaction records may be retained as
        required by law.
      </p>

      <h2>Children’s Privacy</h2>
      <p>
        Our Services are not intended for individuals under 18 years of age. We
        do not knowingly collect personal data from minors.
      </p>

      <h2>Security</h2>
      <p>
        We use reasonable administrative, technical, and physical safeguards to
        protect your information. However, no online transmission is 100%
        secure.
      </p>

      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy periodically. Updates will be posted
        on our website with a revised date.
      </p>

      <h2>Contact Us</h2>
      <p>
        <strong>Viyavar Fashions</strong>
        <br />
        173A, Ceylon Colony, Industrial Estate
        <br />
        Karur, Tamil Nadu – 639004, India
        <br />
        <strong>Email:</strong> viyavarfashion@gmail.com
      </p>
    </div>
  );
};

export default Privatepolicy;
